import { useMemo } from "react";
import type { ThreeEvent } from "@react-three/fiber";
import { getGeometry } from "../lib/loaders";
import { useSceneStore } from "../store/sceneStore";
import type { SceneObjectData } from "../types";

interface Props {
  data: SceneObjectData;
}

export function SceneObjectMesh({ data }: Props) {
  const interactionMode = useSceneStore((s) => s.interactionMode);
  const selectObject = useSceneStore((s) => s.selectObject);
  const addMeasurePoint = useSceneStore((s) => s.addMeasurePoint);

  const geometry = useMemo(
    () => getGeometry(data.id, data.fileBase64, data.format),
    [data.id, data.fileBase64, data.format],
  );

  const handleClick = (event: ThreeEvent<MouseEvent>) => {
    event.stopPropagation();
    if (interactionMode === "measure") {
      addMeasurePoint({ point: [event.point.x, event.point.y, event.point.z] });
    } else {
      selectObject(data.id);
    }
  };

  return (
    <mesh name={data.id} visible={data.visible} geometry={geometry} castShadow receiveShadow onClick={handleClick}>
      <meshStandardMaterial color={data.color} roughness={data.roughness} metalness={data.metalness} />
    </mesh>
  );
}
